import React from "react";
import "./FeedbackSection.scss";

export const FeedbackSection = ({ userComment, onCommentChange, additionalCommentLabel, commentPlaceholder }) => {
  return (
    <div className="feedback-section">
      <div className="feedback-section__comment">
        <label htmlFor="userComment" className="feedback-section__comment-label">
          {additionalCommentLabel}
        </label>
        <textarea
          id="userComment"
          value={userComment}
          onChange={onCommentChange}
          className="feedback-section__comment-textarea"
          rows={3}
          placeholder={commentPlaceholder}
        />
      </div>
    </div>
  );
};
